import React from 'react'
import MiniCard from './MiniCard'

export default function MiniCardDiv({
  card,
  onCardClick,
  labelSize = 'small',
  className
} = {}) {
  return (
    <div className={`flex ${className}`}>
      <MiniCard
        card={card}
        labelSize={labelSize}
        onCardClick={onCardClick}
      />
    </div>
  )
}
